import type { MessageRenderer, RendererConfig, RendererResult, AnimationState } from './types';

/**
 * Renderer that displays content line by line with delay
 */
export class LineByLineRenderer implements MessageRenderer {
  render(
    _messageId: string,
    config: RendererConfig,
    currentState: AnimationState
  ): RendererResult {
    const lines = config.content.split('\n');
    const visibleCount = currentState.visibleLines ?? 0;

    return {
      displayContent: lines.slice(0, visibleCount).join('\n'),
      isComplete: visibleCount >= lines.length,
    };
  }

  getInitialState(): AnimationState {
    // Start with 1 line visible immediately
    return { visibleLines: 1 };
  }
}

